module.exports = __webpack_public_path__ + "static/media/print-logo-7.5535d1e2.png";